import { render, staticRenderFns } from "./listTransfer.vue?vue&type=template&id=40f8e666"
import script from "./listTransfer.js?vue&type=script&lang=js&external"
export * from "./listTransfer.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports